export default "__VITE_ASSET__CyE2KACF__"